import { render, staticRenderFns } from "./printHistory.vue?vue&type=template&id=47335991&scoped=true&"
import script from "./printHistory.vue?vue&type=script&lang=js&"
export * from "./printHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47335991",
  null
  
)

export default component.exports